module.exports = __webpack_public_path__ + "img/六门控制器 (6).d3494019.jpg";